module.exports = __webpack_public_path__ + "media/src/admin/images/target1-a559b7f888a7fc3967d84c57472441ef.png";